<template>
	<i v-if="isBoolean" :class="booleanIcon" />
	<span v-else>
		<i v-if="isIcon" :class="iconClass" />
		<span> {{ formatedValue }} </span>
	</span>
</template>

<script>
import Vue from 'vue';
import _ from 'lodash';
import { formatDateTime, formatDate, formatTime } from '@/main/utils/dateFormatter';
import { zaokrouhli } from '@/main/utils/numbers';

export default Vue.extend({
	name: 'DmsTableCell',
	props: {
		decimalRequired: { type: Boolean, default: false },
		value: [String, Number, Boolean, Date],
		valueType: String,
		iconClass: String,
		colName: String,
	},
	data() {
		return {
			partLimit: 'PARTS_LIMITS',
		};
	},
	computed: {
		isBoolean() {
			return this.valueType === 'Boolean';
		},
		isDate() {
			return ['DateTime', 'Date', 'Time'].includes(this.valueType);
		},
		isIcon() {
			return !!this.iconClass;
		},
		booleanIcon() {
			if (this.value === null) return null;
			return this.value ? 'el-icon-check' : 'el-icon-close';
		},
		formatedValue() {
			let formattedValue = 0;
			switch (this.valueType) {
				case 'DateTime':
					return formatDateTime(this.value);
				case 'Date':
					return formatDate(this.value);
				case 'Time':
					return formatTime(this.value);
				case 'Decimal':
					if (this.decimalRequired) {
						formattedValue = (_.isNil(this.value)) ? this.value : Number(this.value).toLocaleString(this.Language, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
					} else {
						formattedValue = (_.isNil(this.value)) ? this.value : Number(this.value.toFixed(2)).toLocaleString(this.Language);
					}
					return formattedValue;
				default:
					return this.value;
			}
		},
	},
});
</script>

<style lang="scss" scoped>
.ellipsis td:before {
	content: '&nbsp;';
	visibility: hidden;
}

.ellipsis span {
	position: absolute;
	left: 0;
	right: 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

span {
	white-space: pre;
}
</style>
